export default __webpack_public_path__ + "static/media/Politica_Qualita_Ambiente_Sicurezza.ef465ea8.pdf";